export default __webpack_public_path__ + "static/media/m-41.4196146f.svg";